<template>
    <div
      class="lcu-announcement-wrapper"
      v-for="(item, index) in globalAnnouncements"
      :key="index">
      <button
        class="lcu-announcement-close"
        @click.prevent="removeAnnouncement(index)" />
      <div
        class="lcu-announcement-inner"
        :class="'lcu-announcement-' + item.type">
        <span
          :class="'lcu-announcementIcon-' + item.type"
          class="lcu-announcement-icon"/>
        <span>
          {{ item.text }}
        </span>
      </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'annoucement-banner',
  computed: {
    ...mapGetters(['globalAnnouncements']),
  },
  props: {
    announcements: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  methods: {
    removeAnnouncement(index) {
      this.$store.dispatch('removeGlobalAnnouncement', index);
    },
  },
};
</script>

<style scoped lang="scss">
.lcu-announcement-wrapper {
  position: relative;
  margin-bottom: 35px;

  &:last-child {
    margin-bottom: 0;
  }
}

.lcu-announcement-inner {
  display: grid;
  grid-template-columns: max-content 1fr;
  grid-gap: 10px;
  color: rgba($black, .6);
  padding: 15px;
  background-color: #ecf8ff;
  border: 1px solid rgba($black, .3);
  border-radius: 5px;
  align-items: center;
}

.lcu-announcement-warn {
  background-color: #fdf6db;
}

.lcu-announcement-icon {
  color: rgba($black, .5);

  &:before {
    display: inline-block;
    font-family: 'lcu';
    content: '\e821';
    font-size: 32px;
  }
}

.lcu-announcement-close {
  position: absolute;
  background-color: transparent;
  border: 0;
  top: 7px;
  right: 2px;
  color: rgba($black, .4);

  &:hover {
    cursor: pointer;
  }

  &:before {
    display: inline-block;
    font-family: 'lcu';
    content: '\e811';
  }
}

.lcu-announcementIcon-warn {

  &:before {
    content: '\e822';
  }
}
</style>
